var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "tabs-left col-xs-12 p-24" },
        [
          [
            _c(
              "ul",
              { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
              [
                _c(
                  "li",
                  {
                    staticClass: "nav-item",
                    class: { active: _vm.activeName === "expiry" },
                    attrs: { role: "presentation" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "nav-link",
                        attrs: { role: "tab", "data-toggle": "tab" },
                        on: {
                          click: function ($event) {
                            return _vm.setTab("expiry")
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "dashboard-icons",
                          attrs: {
                            src: "/static/images/market-place/icons/reg_tracker_icon.svg",
                          },
                        }),
                        _vm._v(" Expiry "),
                      ]
                    ),
                  ]
                ),
                _c(
                  "li",
                  {
                    staticClass: "nav-item",
                    class: { active: _vm.activeName === "pending" },
                    attrs: { role: "presentation" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "nav-link",
                        attrs: { role: "tab", "data-toggle": "tab" },
                        on: {
                          click: function ($event) {
                            return _vm.setTab("pending")
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "dashboard-icons",
                          attrs: {
                            src: "/static/images/market-place/icons/reg_tracker_icon.svg",
                          },
                        }),
                        _vm._v(" Pending "),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c("div", { staticClass: "tab-content custom_tab_content" }, [
        _vm.selectedMenu == "expiry"
          ? _c(
              "div",
              {
                staticClass: "tab-pane expi_tab content_tab",
                class: _vm.selectedMenu == "expiry" ? "active" : "",
              },
              _vm._l(_vm.expirationDetails, function (item, key, index) {
                return _c("div", { key: index }, [
                  _c("p", { staticClass: "tab_expiry" }, [
                    key === "expired"
                      ? _c("span", [_vm._v("Expired")])
                      : _vm._e(),
                    key === "month"
                      ? _c("span", [_vm._v("Expiring this month")])
                      : _vm._e(),
                    key === "quarter"
                      ? _c("span", [_vm._v("Expiring next 3 months")])
                      : _vm._e(),
                    key === "year"
                      ? _c("span", [_vm._v("Expiring this year")])
                      : _vm._e(),
                    _c("span", { staticClass: "progress_count" }, [
                      _vm._v(_vm._s(item.number)),
                    ]),
                  ]),
                  _c("div", { staticClass: "progress" }, [
                    _c("div", {
                      staticClass: "progress-bar",
                      class: {
                        expired: key === "expired",
                        expiring_month: key === "month",
                        expiring_3months: key === "quarter",
                        expiring_year: key === "year",
                      },
                      style: { width: item.number + "%" },
                      attrs: {
                        "aria-valuenow": item.number,
                        "aria-valuemin": 0,
                        "aria-valuemax": 100,
                      },
                    }),
                  ]),
                ])
              }),
              0
            )
          : _vm.selectedMenu == "pending"
          ? _c(
              "div",
              {
                staticClass: "tab-pane pen_tab content_tab",
                class: _vm.selectedMenu == "pending" ? "active" : "",
              },
              _vm._l(_vm.pendingSummary, function (item, key, index) {
                return _c("div", { key: index }, [
                  _c("p", { staticClass: "tab_expiry" }, [
                    key === "initial"
                      ? _c("span", [_vm._v("Initial Registrations")])
                      : _vm._e(),
                    key === "modification"
                      ? _c("span", [_vm._v("Modifications")])
                      : _vm._e(),
                    key === "renewal"
                      ? _c("span", [_vm._v("Renewals")])
                      : _vm._e(),
                    _c("span", { staticClass: "progress_count" }, [
                      _vm._v(_vm._s(item.number)),
                    ]),
                  ]),
                  _c("div", { staticClass: "progress" }, [
                    _c("div", {
                      staticClass: "progress-bar",
                      class: {
                        initial: key === "initial",
                        modif: key === "modification",
                        renew: key === "renewal",
                      },
                      style: { width: item.number + "%" },
                      attrs: {
                        "aria-valuenow": item.number,
                        "aria-valuemin": 0,
                        "aria-valuemax": 100,
                      },
                    }),
                  ]),
                ])
              }),
              0
            )
          : _vm._e(),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }